/**
 * ตัวช่วยอ่านข้อความ error จาก API ให้ user เห็นว่า "พังตรงไหน"
 *
 * BE ตอบ error กลับมา 2 ทรง (ดู api: app/Exceptions/Handler.php)
 *   1) { code, message }                     → ก้อนเดียว เช่น ERROR_KEY_NOT_ALLOWED
 *   2) { code: 'VALIDATION', errors: {...} }  → ราย field (FormValidationException) และ "ไม่มี" message
 *
 * ฟอร์มที่อ่านแต่ `message` เจอทรงที่ 2 แล้วได้ undefined → toast เหลือแค่ "บันทึกไม่สำเร็จ"
 * เคสจริงที่เจอ: อัปรูปแล้ว validation ตกที่ field image (รูป decode ไม่ได้)
 * แต่หน้าจอไม่โชว์ errors.image ที่ไหนเลย user เลยไม่รู้ว่าเป็นเพราะรูป
 */

/**
 * ดึงข้อความ error ทั้งหมดออกมาเป็น array (ยังไม่แปลภาษา)
 */
export function apiErrorMessages(err) {
	const data = err?.response?.data;
	if (!data) return [];

	const errors = data.errors;
	if (errors && typeof errors === 'object') {
		const messages = [];
		Object.keys(errors).forEach((field) => {
			const value = errors[field];
			if (Array.isArray(value)) messages.push(...value);
			else if (value) messages.push(value);
		});
		if (messages.length) return messages.filter(Boolean);
	}

	return data.message ? [data.message] : [];
}

/**
 * รวมเป็นข้อความเดียวพร้อมโชว์ — ส่ง `t` (this.$t) มาด้วยเพื่อแปลตาม translate_missing.csv
 */
export function apiErrorText(err, t) {
	const translate = typeof t === 'function' ? t : (v) => v;
	return apiErrorMessages(err)
		.map((message) => translate(message))
		.join('\n');
}
